import { useEffect, useState } from 'react';

// Refresh reads only: no scheduled backend task, no mutations or clock adjustments.
export const useInternalRefresh = () => {
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const refresh = () => { if (!document.hidden) setRevision(v => v + 1); };
    const timer = window.setInterval(refresh, 30000);
    window.addEventListener('focus', refresh);
    window.addEventListener('storage', refresh);
    return () => { window.clearInterval(timer); window.removeEventListener('focus', refresh); window.removeEventListener('storage', refresh); };
  }, []);
  return revision;
};

export const notifyInternalChange = () => window.localStorage.setItem('internal-staff-updated', String(Date.now()));